import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ShieldAlert } from "lucide-react";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/", { replace: true }); return; }
    login(decodeURIComponent(m[1]))
      .then(() => {
        window.history.replaceState(null, "", window.location.pathname);
        nav("/", { replace: true });
      })
      .catch((e) => setError(e));
  }, []); // eslint-disable-line

  if (error) {
    const blocked = error.status === 403;
    return (
      <div className="login-shell">
        <div className="login-card">
          <div className="cb-icon" style={{ color: blocked ? "#dc2626" : "#ea580c" }}><ShieldAlert size={30} /></div>
          <h1 className="login-title">{blocked ? "Access restricted" : "Sign-in failed"}</h1>
          <p className="login-sub">{error.message}</p>
          <button className="google-btn" onClick={() => { window.location.href = window.location.origin + "/"; }}>
            Back to sign in
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-brand">Dot<span>IQ</span></div>
        <div className="cb-spinner" />
        <p className="login-sub">Signing you in…</p>
      </div>
    </div>
  );
}
